import { render } from "./SysDefineVersion.vue?vue&type=template&id=5e26c3fa&scoped=true"
import script from "./SysDefineVersion.vue?vue&type=script&lang=js"
export * from "./SysDefineVersion.vue?vue&type=script&lang=js"

import "./SysDefineVersion.vue?vue&type=style&index=0&id=5e26c3fa&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e26c3fa"]])

export default __exports__